@if (model()) {
  <div class="d-flex justify-content-between my-3">
    <div class="d-flex flex-column gap-3 w-50">
      @if (!model().logoPath) {
        <img src="assets/logos/company/{{ model().key }}.png" class="img-fluid" alt="" />
      }
      @if (model().logoPath) {
        <img src="{{ model().logoPath }}" class="img-fluid" alt="" />
      }
    </div>
    <div>
      <strong>
        @if (model().name) {
          {{ model().name }}<br />
        }
        @if (model().line1) {
          {{ model().line1 }}<br />
        }
        @if (model().line2) {
          {{ model().line2 }}<br />
        }
        @if (model().line3) {
          {{ model().line3 }}<br />
        }
        @if (model().line4) {
          {{ model().line4 }}<br />
        }
        @if (model().townCity) {
          {{ model().townCity }}<br />
        }
        @if (model().postCode) {
          {{ model().postCode }}<br />
        }
        @if (model().country) {
          {{ model().country }}<br />
        }
        <br />
        @if (model().tel) {
          {{ telLabel }}: {{ model().tel }}<br />
        }
        @if (model().fax) {
          <span i18n>Fax</span>: {{ model().fax }}<br />
        }
        @if (model().email) {
          <span i18n>Email</span>: {{ model().email }}<br />
        }
        @if (model().web) {
          {{ webLabel }}: {{ model().web }}<br />
        }
        <br />
        @if (model().vatRegNo) {
          {{ model().vatRegNo }}<br />
        }
        @if (model().eoriNo) {
          {{ model()?.eoriNo }}<br />
        }
      </strong>
    </div>
  </div>
}
<div class="d-flex justify-content-between align-items-center">
  <h1>{{ header() }}</h1>
  <ng-content></ng-content>
</div>

<hr />
